module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABJklEQVQ4T9XSvUoDQRAH8P9c8Ah+ErHwGfYgFnsvYOED2Cg+gHd+4BtY2FkoWIlcsLARyXUivoHp7g5F9oKdIDZBOBBRSSQjm3DxckmKlE63s/PbGXaXrIr9wsACxggC3miM+r7SoVD4wqSkuAMDLfUaneEA7XyDASg9OfFNqAJYAfAJ4Fpthi4InMV9sIeYmkxoMHPdMLAKxnMe/0EfBZHIK31qXAo3rMQ+Zmo/vH80qrMzizfE/KSccDft2oU+ClZiX4LYLDLWQzdsWZ59omHsRBflo/LUz5x5S8CjcoI9TTrQqshzAPMp6uQyUK97mHGn3GC/Cz25zKWvWrwWN9NR8lDnxamYJmNySW0HtZHvOAyOvNXsxj+CwpOHzHxf34r0LxqIXyrrlesCqVNdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/caigou/shang1.png
// module id = radV
// module chunks = 4